export const VERSION = '1.4.11';
//# sourceMappingURL=version.js.map